import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import apiRequest from '../../lib/http'

const OfficeSelector = () => {
  const [offices, setOffices] = useState([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const fetchOffices = async () => {
      try {
        const res = await apiRequest.get('/affiliates/my-offices')
        const data = res.data.data || []
        setOffices(data)

        if (data.length <= 1) {
          if (data.length === 1) {
            localStorage.setItem('activeOfficeId', data[0]._id)
          }
          navigate('/', { replace: true })
        }
      } catch (err) {
        console.error('Failed to fetch offices:', err)
      } finally {
        setLoading(false)
      }
    }
    fetchOffices()
  }, [])

  const handleSelect = (officeId) => {
    localStorage.setItem('activeOfficeId', officeId)
    window.location.assign('/')
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-surface flex items-center justify-center">
        <div className="text-text-secondary">Loading...</div>
      </div>
    )
  }

  if (offices.length <= 1) {
    return null
  }

  return (
    <div className="min-h-screen bg-surface flex items-center justify-center">
      <div className="border border-divider/20 shadow-lg rounded-2xl p-12 max-w-md w-full">
        <h1 className="text-2xl font-bold text-text-primary mb-2">Select Office</h1>
        <p className="text-text-secondary mb-8">
          Choose which office you are working in. Contacts, payments and settings all follow this choice.
        </p>
        <div className="space-y-3">
          {offices.map((office) => (
            <button
              key={office._id}
              onClick={() => handleSelect(office._id)}
              className="w-full text-left p-4 rounded-xl border border-divider/20 hover:border-primary hover:bg-primary/5 transition-colors"
            >
              <div className="font-semibold text-text-primary">{office.name}</div>
              {office.isOwner && <div className="text-sm text-text-secondary">Group owner</div>}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

export default OfficeSelector
